import angular from "angular";
import route from "./request_access.route";
import ctrl from "./request_access.controller";
import "angular-ui-router";

export default angular
    .module("sbApp.requestAccess", ["ui.router"])
    .config(route)
    .controller("RequestAccessCtrl", ctrl);
